import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-horecavergunning',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconHorecavergunning {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M1 26.98h9v8.99h-.06L1 27.02v-.03Zm11 8.99v-9.08c0-1.06-.86-1.91-1.92-1.91H1V1.97C1 .88 1.88 0 2.97 0h24.05c1.09 0 1.97.88 1.97 1.97v14.02H24c-1.66 0-3 1.35-3 3 0 1.97 0 4.2.01 4.33.13 3.16 2.14 5.91 4.98 7.07v1.59h-.1c-2.22 0-4.03 1.79-4.03 4h-9.88Zm2.34-16.68 7.11-7.1c.38-.38.38-1 0-1.38l-.02-.02c-.38-.38-1-.38-1.38 0l-6.41 6.41-3.56-3.54c-.38-.38-1-.38-1.38 0a.96.96 0 0 0 0 1.38l4.26 4.26c.38.38 1 .38 1.38 0ZM30 28.88v5.09h2.02a2 2 0 0 1 2 2l-10.11.02c0-1.13.92-2.02 2.05-2.02H28v-5.09a5.987 5.987 0 0 1-4.99-5.65c0-.02 0-2.74-.01-4.25 0-.55.45-1 1-1h10c.55 0 1 .44 1 1 0 1.52 0 4.24-.01 4.26-.12 2.85-2.23 5.18-4.99 5.65Zm2.97-8.9h-7.95v3h7.94v-3Z"/>
</svg>

    );
  }
}
